var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-source" },
    [
      _vm.getIsTizen
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsLG && _vm.getLGVersion >= "5.0"
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getLGVersion < "5.0"
        ? _c("video", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsOrsay
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.getIsOrsay && !_vm.getIsLG && !_vm.getIsTizen
        ? _c("video", {
            staticClass: "tv-player__video",
            attrs: {
              src: "https://media.digmedia.net/website/video/rain_264.mp4?_=1",
              muted: "",
              autoplay: "",
              loop: ""
            },
            domProps: { muted: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showOSD
          ? _c("div", { staticClass: "input-source__osd" }, [
              _c("div", { staticClass: "osd__header" }, [
                _c(
                  "div",
                  { staticClass: "osd-back osd-back--active" },
                  [
                    _c(
                      "Icon",
                      { attrs: { color: "#f1f1f1" } },
                      [_c("ArrowLeft")],
                      1
                    ),
                    _vm._v(" " + _vm._s(_vm.getBack) + "\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tv-osd__header-title" }, [
                  _vm._v(_vm._s(_vm.source) + " " + _vm._s(_vm.port))
                ])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db639de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db639de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InputSource.vue
// module id = null
// module chunks = 